<template>
  <v-card outlined :loading="loading" :min-width-400="$vuetify.breakpoint.smAndUp" :min-width-300="$vuetify.breakpoint.xsOnly">
    <v-snackbar v-model="snackbar.show" top :color="snackbar.color">
      {{ snackbar.text }}
    </v-snackbar>

    <v-card-title>
      <div class="subtitle-1">{{ companyName }}</div>
    </v-card-title>
    <v-card-subtitle>
      <div class="ml-4 headline">Verify your email</div>
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-text-field
          label="Email"
          name="email"
          type="text"
          :disabled="activate"
          :rules="[rules.required, rules.email]"
          v-model="data.email"
          prepend-inner-icon="email"
          outlined
          autofocus
        ></v-text-field>
        <v-btn :disabled="resendDelay > 0 || !valid" large block color="success lighten-1" @click="send">
          Send email <span v-if="resendDelay > 0">(Re-send in {{ resendDelay}}s)</span>
        </v-btn>
      </v-form>

      <v-form ref="form2" v-model="valid2" class="mt-8">
        <label>Please verify in 15 minutes</label>
        <v-text-field
          label="Code in the email"
          name="code"
          :rules="[rules.required, rules.code]"
          v-model="data.code"
          v-mask="'######'"
          outlined
          ref="code"
        ></v-text-field>
        <v-btn :disabled="!valid2" large block color="success lighten-1" @click="vurify">
          Verify
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import UserService from '@/services/UserService.js'

export default {
  name: 'Verify',
  directives: {
    mask
  },
  props: {
    activate: Boolean
  },
  data: () => ({
    loading: false,
    valid: false,
    valid2: false,
    rules: {
      required: v => !!v || 'Required',
      email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      code: v => v.length === 6 || 'Input 6 digits'
    },
    snackbar: {
      show: false,
      color: null,
      text: null
    },
    resendDelay: 0,
    secInerval: null,
    data: {
      email: '',
      code: ''
    }
  }),
  computed: {
    ...mapGetters([
      'companyName'
    ])
  },
  methods: {
    ...mapActions([
      'setUser'
    ]),
    setData (email) {
      this.data.email = email
    },
    send () {
      this.loading = true
      UserService.sendCode({ email: this.data.email })
        .then(resp => {
          setTimeout(() => {
            this.loading = false
          }, 500)
          this.resendDelay = 60
          this.$refs.form.resetValidation()
          this.snackbar.color = 'success'
          this.snackbar.text = 'Please check your email and input the code to verify.'
          this.snackbar.show = true
          this.$refs.code.focus()
          this.secInterval = setInterval(() => {
            if (this.resendDelay === 0 && this.secInterval) {
              clearInterval(this.secInterval)
              this.secInverval = null
            } else {
              this.resendDelay--
            }
          }, 1000)
        })
        .catch(err => {
          console.error(err)
          this.loading = false
          this.$refs.form.resetValidation()
          this.snackbar.show = true
          this.snackbar.color = 'error'
          this.snackbar.text = 'Failed to send code.'
        })
    },
    vurify () {
      this.loading = true
      UserService.verifyCode(this.data)
        .then(resp => {
          this.loading = false
          this.$refs.form2.resetValidation()
          this.$emit('set-auth-state', {
            state: 'reset',
            email: resp.data.email,
            code: resp.data.code,
            message: 'Email verified! Please reset your password.'
          })
        })
        .catch(err => {
          console.error(err)
          this.loading = false
          this.$refs.form2.resetValidation()
          this.snackbar.show = true
          this.snackbar.color = 'error'
          this.snackbar.text = 'Failed to verify code.'
        })
    }
  }
}
</script>
